import { QualityReport } from '../types/quality'
import { company } from './company'

export const qualityReports: QualityReport[] = [
  {
    id: 'ks-2026-0002',
    reportId: 'KS-2026-0002',
    title: 'Asbesttag nedtagning og fjernelse',
    status: 'Åben',
    visibleToCustomer: true,
    description:
      'Denne kvalitetssikring dokumenterer nedtagning og bortskaffelse af asbesttag. Kontrolpunkterne udfyldes løbende med foto, så arbejdet kan dokumenteres inden taget lukkes igen.',
    customer: {
      name: 'Stefan Sørensen',
      address: 'Skolevej 23, 8464 Galten',
    },
    quote: {
      reference: 'TIL-2026-0028',
      status: 'Accepteret',
      amount: 80000,
    },
    project: {
      reference: 'PRJ-2026-0007',
      title: 'Asbesttag nedtagning og fjernelse',
    },
    responsible: {
      name: 'Stefan Sørensen',
      email: 'stefan@lykke-el.dk',
      phone: '+45 20 41 88 12',
    },
    company: { ...company },
    sections: [
      {
        id: 'sec-proces',
        title: 'Asbesttag, proceskontrol',
        kind: 'Proceskontrol',
        points: [
          {
            id: 'kp-1',
            title: 'Tag undersøgt før nedtagning',
            status: 'pending',
            requiresPhoto: true,
          },
          {
            id: 'kp-2',
            title: 'Arbejdsområde afspærret',
            status: 'ok',
            requiresPhoto: true,
            note: 'Afspærret med tape og skiltning mod vej.',
          },
          {
            id: 'kp-3',
            title: 'Asbestplader fjernet',
            status: 'pending',
            requiresPhoto: true,
          },
        ],
      },
      {
        id: 'sec-slut',
        title: 'Asbesttag, slutkontrol',
        kind: 'Slutkontrol',
        points: [
          {
            id: 'kp-4',
            title: 'Område rengjort efter fjernelse',
            status: 'pending',
            requiresPhoto: true,
          },
        ],
      },
    ],
    photos: [
      {
        id: 'photo-1',
        url: 'https://cdn.magicpatterns.com/patterns/generated-images/d509a740-8ce8-421e-85a0-962246f28250.jpg',
        takenAt: '2026-07-22T19:28:00',
        description: 'Tag før nedtagning',
      },
      {
        id: 'photo-2',
        url: 'https://cdn.magicpatterns.com/patterns/generated-images/21a90554-6237-46c9-b64d-7fadcf430b73.jpg',
        takenAt: '2026-07-22T19:28:00',
        controlPointId: 'kp-2',
        description: 'Asbestplader emballeret',
      },
      {
        id: 'photo-3',
        url: 'https://cdn.magicpatterns.com/patterns/generated-images/47b00378-fb07-4838-b5a1-9816814e4eee.jpg',
        takenAt: '2026-07-22T19:24:00',
        controlPointId: 'kp-2',
        description: 'Afspærring mod vej',
      },
    ],
  },
  {
    id: 'ks-2026-0001',
    reportId: 'KS-2026-0001',
    title: 'Ladeboksinstallation, carport',
    status: 'Afsluttet',
    visibleToCustomer: true,
    description:
      'Installation af ladeboks i carport med ny gruppe i tavle. Alle kontrolpunkter er registreret og dokumenteret med foto.',
    customer: {
      name: 'Mette Holm',
      address: 'Bakkevej 8, 8382 Hinnerup',
    },
    quote: {
      reference: 'TIL-2026-0019',
      status: 'Accepteret',
      amount: 24500,
    },
    project: {
      reference: 'PRJ-2026-0004',
      title: 'Ladeboksinstallation, carport',
    },
    responsible: {
      name: 'Stefan Sørensen',
      email: 'stefan@lykke-el.dk',
      phone: '+45 20 41 88 12',
    },
    company: { ...company },
    sections: [
      {
        id: 'sec-lade-proces',
        title: 'Ladeboks, proceskontrol',
        kind: 'Proceskontrol',
        points: [
          {
            id: 'lkp-1',
            title: 'Gruppe afsat i tavle',
            status: 'ok',
            requiresPhoto: false,
          },
          {
            id: 'lkp-2',
            title: 'Kabelføring fastgjort',
            status: 'ok',
            requiresPhoto: false,
          },
        ],
      },
      {
        id: 'sec-lade-slut',
        title: 'Ladeboks, slutkontrol',
        kind: 'Slutkontrol',
        points: [
          {
            id: 'lkp-3',
            title: 'Funktionstest gennemført',
            status: 'ok',
            requiresPhoto: false,
          },
        ],
      },
    ],
    photos: [],
  },
]
